import { Badge, Card, ListGroup, ListGroupItem } from "react-bootstrap";
import CommonUtils from "../../../utils/common";
import { useNavigate } from "react-router-dom";
import { useAuthState } from "../../../context/AuthContext";

const TicketsCard = ({tickets}) => {

    const { user } = useAuthState();
    const UTILS = new CommonUtils();
    const navigate = useNavigate();

    return (
        <Card className="radius-20 shadow-lg">
            <Card.Body>
                <h5>Tickets</h5>
                <ListGroup variant="flush">
                    {tickets && tickets.length > 0 ?
                        tickets.map(t => (
                            <ListGroupItem key={t.id} action onClick={() => navigate(`${user.x_is_house_management? '/hw':''}/dashboard/support/${t.id}`) }>
                                <div className="d-flex flex-column">
                                    <div className="d-flex justify-content-between align-items-center">
                                        {t.name}
                                        <Badge bg="energo">{t.stage_id[1]}</Badge>
                                    </div>
                                    {UTILS.dateToEuFormat(t.create_date)}
                                </div>
                            </ListGroupItem>
                        ))
                        :
                        <ListGroupItem><small>Keine Tickets.</small></ListGroupItem>
                    }
                </ListGroup>
            </Card.Body>
        </Card>
    )
}
export default TicketsCard;